import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { withStyles, Slide } from "@material-ui/core";
import { withTranslation } from "react-i18next";
import Selector2 from "../Selector2";
import NumberFormat from "react-number-format";
import {
  verifyPhone,
  cleanPhoneResponse,
  fetchNationalities,
  pushNotification,
  fetchPhoneCodes,
} from "../../actions/index";
import { images } from "../../utils/images";
import Loader from "../Loader";
// PROPS NEEDED FOR SELECTOR2
// options "Array of Strings",
// width "Number"
// maxWidth "Number"
// selectorHandler "Function to trigger on change"
// selectedOption "String"

function PhoneVerification(props) {
  const { classes, t, moveForward, phoneResponse, nationalities, phoneCodes } =
    props;
  const [code, setCode] = useState("");
  const [phone, setPhone] = useState("");
  const [nationality, setNationality] = useState("");
  const [verificationCode, setVerificationCode] = useState("");
  const [codeSent, setCodeSent] = useState(false);
  const [phoneError, setPhoneError] = useState(null);
  const [verifying, startVerification] = useState(false);
  const [nationalitiesArray, setNatArray] = useState([]);
  const [codesArray, setCodesArray] = useState([]);

  // Component Did Mount
  useEffect(() => {
    props.fetchNationalities();
    props.fetchPhoneCodes();

    return () => {
      setCodeSent(false);
      props.cleanPhoneResponse();
    };
  }, []);

  useEffect(() => {
    if (nationalities) {
      let natArray = [];

      nationalities.map((n) => {
        natArray.push(n.name);
      });

      setNatArray([...natArray]);
    }
  }, [nationalities]);

  useEffect(() => {
    if (phoneCodes) {
      let codesArray = [];

      phoneCodes.map((c) => {
        let string = `${c.code} ${c.zone_name}`;
        codesArray.push(string);
      });

      setCodesArray([...codesArray]);
    }
  }, [phoneCodes]);

  useEffect(
    function () {
      if (phoneResponse.method === "none") {
        props.setNationality(nationality);
        props.cleanPhoneResponse();
        moveForward(true);
      }

      if (phoneResponse.method !== null && phoneResponse.error === null) {
        if (phoneResponse.method !== "none") {
          pushNotification({ message: t("codeSent"), type: "success" });
        }
        setCodeSent(true);
        setPhoneError(null);
      }

      if (phoneResponse.method === null && phoneResponse.error) {
        startVerification(false);
        if (
          phoneResponse.error.number &&
          phoneResponse.error.number[0] === "is invalid"
        ) {
          props.pushNotification({
            message: t("numberInvalid"),
            type: "error",
          });
          setPhoneError("numberInvalid");
        } else {
          if (phoneResponse.error.number) {
            props.pushNotification({
              message: phoneResponse.error.number[0],
              type: "error",
            });
            setPhoneError(phoneResponse.error.number[0]);
          }
          if (phoneResponse.error.base) {
            props.pushNotification({
              message: phoneResponse.error.base[0],
              type: "error",
            });
            setPhoneError(phoneResponse.error.base[0]);
          }

          if (phoneResponse.error === "_tooManyRequests") {
            props.pushNotification({
              message: t(phoneResponse.error),
              type: "error",
            });
          }
        }
      }

      if (phoneResponse.code_verified) {
        props.pushNotification({
          message: t("phoneVerified"),
          type: "success",
        });
        props.setNationality(nationality);
        props.cleanPhoneResponse();
        moveForward(true);
      }
    },
    [phoneResponse]
  );

  const startPhoneVerification = () => {
    startVerification(true);

    const data = {
      number: `${code.split(" ")[0]}${phone}`,
      preferred_verification_method: "sms",
    };

    props.verifyPhone(data);
  };

  const submitVerificationCode = () => {
    const data = {
      code: verificationCode,
    };

    props.verifyPhone(data);
  };

  const resendVerificationCode = () => {
    const data = {
      number: `${code.split(" ")[0]}${phone}`,
      preferred_verification_method: "sms",
    };

    props.verifyPhone(data);
  };

  if (nationalities === null || phoneCodes === null) {
    return (
      <div style={{ marginTop: 24 }}>
        <Loader />
      </div>
    );
  }

  return (
    <Slide in direction="left">
      <div className={classes.container}>
        <h2 dangerouslySetInnerHTML={{ __html: t("verifyYourPhone") }} />
        <div className="stepBody">
          {codeSent ? (
            <div className="left">
              <p
                className="label"
                dangerouslySetInnerHTML={{
                  __html: t("codeSentTo", {
                    number: `${code.split(" ")[0]}${phone}`,
                  }),
                }}
              />
              <div className="codeInput">
                {/* <NumberFormat
                  className="textInput"
                  decimalScale={0}
                  allowNegative={false}
                  allowLeadingZeros={true}
                  onFocus={(e) => e.target.select()}
                  value={verificationCode}
                  onChange={(e) => setVerificationCode(e.currentTarget.value)}
                  placeholder={t("enterVerificationCode")}
                /> */}
                <input
                  type="text"
                  className="textInput"
                  onFocus={(e) => e.target.select()}
                  value={verificationCode}
                  onChange={(e) => setVerificationCode(e.currentTarget.value)}
                  placeholder={t("enterVerificationCode")}
                />
                {phoneError ? (
                  <p
                    className="passRequirements notMatch"
                    style={
                      phoneError
                        ? { height: "auto", marginBottom: 16 }
                        : { height: 0, overflow: "hidden" }
                    }
                  >
                    <img src={images.icons.error} />
                    {t(phoneError)}
                  </p>
                ) : (
                  ""
                )}
                <p
                  className="resendCodeP"
                  onClick={() => resendVerificationCode()}
                >
                  {t("resendCode")}
                </p>
              </div>
              <button
                className="confirmBtn"
                onClick={() => submitVerificationCode()}
              >
                {t("confirm")}
              </button>
            </div>
          ) : (
            <div className="left">
              <p className="label">{t("countryCode")}</p>
              <div className="phoneInput">
                <Selector2
                  options={codesArray}
                  selectorHandle={setCode}
                  selectedOption={code}
                  maxWidth={165}
                  width={"100%"}
                />
                <NumberFormat
                  className="textInput"
                  decimalScale={0}
                  allowNegative={false}
                  allowLeadingZeros={true}
                  onFocus={(e) => e.target.select()}
                  value={phone}
                  onChange={(e) => setPhone(e.currentTarget.value)}
                  placeholder={t("enterPhone")}
                />
              </div>
              {phoneError ? (
                <p
                  className="passRequirements notMatch"
                  style={
                    phoneError
                      ? { height: "auto", marginBottom: 16, marginTop: 8 }
                      : { height: 0, overflow: "hidden" }
                  }
                >
                  <img src={images.icons.error} />
                  {t(phoneError)}
                </p>
              ) : (
                ""
              )}
              <p className="label">{t("nationality")}</p>
              <Selector2
                options={nationalitiesArray}
                selectorHandle={setNationality}
                selectedOption={nationality}
                width="100%"
              />
              <button
                className="confirmBtn"
                disabled={
                  nationality === "" || code === "" || phone === "" || verifying
                }
                onClick={() => startPhoneVerification()}
              >
                {t("confirm")}
              </button>
            </div>
          )}
          <div className="right">
            <img
              style={{ width: "auto", height: "100%", objectFit: "contain" }}
              src={images.illustrations.phoneIllustrationSolo}
            />
          </div>
        </div>
      </div>
    </Slide>
  );
}

function mapStateToProps(state) {
  return {
    phoneResponse: state.phoneResponse,
    nationalities: state.nationalities,
    phoneCodes: state.phoneCodes,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      verifyPhone,
      cleanPhoneResponse,
      fetchNationalities,
      pushNotification,
      fetchPhoneCodes,
    },
    dispatch
  );
}

const styles = (theme) => ({
  container: {
    margin: "0 auto",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    background: theme.colors.background.fore,
    boxShadow: theme.defaults.shadow,
    maxWidth: 880,
    width: "90%",
    padding: 40,
    color: theme.colors.text.primary,
    [theme.breakpoints.down(500)]: {
      padding: 24,
    },

    "& h2": {
      fontSize: 28,
      fontWeight: 300,
      "& b": {
        fontWeight: 600,
      },
    },

    "& .stepBody": {
      marginTop: 40,
      display: "flex",
      width: "100%",
      justifyContent: "space-between",

      "& .left": {
        width: "50%",
        position: "relative",

        "& .label": {
          fontSize: 14,
          color: theme.colors.text.secondary,
          fontFamily: "DM Sans, sans-serif",
          marginBottom: 8,
          "& b": {
            color: theme.colors.text.primary,
            fontWeight: 600,
          },
        },

        "& .phoneInput": {
          display: "flex",
          marginBottom: 16,
          justifyContent: "space-between",
          "& input": theme.defaults.input,

          "& .textInput": {
            width: "55%",
            "&:focus": {
              border: `1px solid ${theme.colors.text.primary}`,
              color: theme.colors.text.primary,
            },
          },
        },
        "& .passRequirements": {
          fontSize: 14,
          // fontFamily: "Titillium Web",
          lineHeight: "21px",
          color: theme.colors.text.secondary,
          display: "flex",
          justifyContent: "flex-end",
          "& img": {
            width: 12,
            height: 12,
            marginRight: 6,
            marginTop: 4,
          },

          "&.notMatch": {
            color: theme.colors.buttons.sell,
            "& img": {
              width: 16,
              height: 16,
              marginRight: 6,
              marginTop: 0,
            },
          },
        },

        "& .codeInput": {
          "& input": {
            ...theme.defaults.input,
            "&:focus": {
              border: `1px solid ${theme.colors.text.primary}`,
              color: theme.colors.text.primary,
            },
          },

          "& .textInput": {
            maxWidth: "100%",
          },

          "& .resendCodeP": {
            fontSize: 18,
            cursor: "pointer",
            transition: ".3s",
            textDecoration: "underline",
            marginTop: 16,
            "&:hover": {
              color: theme.colors.text.secondary,
            },
          },
          "& .passRequirements": {
            fontSize: 14,
            // fontFamily: "Titillium Web",
            lineHeight: "21px",
            color: theme.colors.text.secondary,
            display: "flex",
            "& img": {
              width: 12,
              height: 12,
              marginRight: 6,
              marginTop: 4,
            },

            "&.notMatch": {
              color: theme.colors.buttons.sell,
              "& img": {
                width: 16,
                height: 16,
                marginRight: 6,
                marginTop: 0,
              },
            },
          },
        },

        "& button": theme.defaults.roundBtn,
        "& .confirmBtn": {
          background: theme.colors.buttons.green,
          marginTop: "25%",
          float: "right",
          width: 160,
          height: 48,
          fontSize: 18,
        },
      },
      "& .right": {
        width: "45%",
        height: 300,
        display: "flex",
        justifyContent: "alignItems",
        flexDirection: "column",
      },
      [theme.breakpoints.down(700)]: {
        "& .left": {
          width: "100%",
          "& .phoneInput": {
            marginRight: "0 !important",
          },
        },
        "& .right": {
          display: "none",
        },
      },
      [theme.breakpoints.down(500)]: {
        "& .left": {
          "& .phoneInput": {
            flexDirection: "column",
            "& .textInput": {
              marginTop: 12,
              width: "100% !important",
            },
          },
        },
      },
    },
  },
});

export default withStyles(styles)(
  withTranslation()(
    connect(mapStateToProps, mapDispatchToProps)(PhoneVerification)
  )
);
